module.exports = __webpack_public_path__ + "img/Proliferation-PRCA_10X_AIC.7d1e1d70.png";